<template>
  <div>
    <v-snackbar v-model="showAlert" :top="true" color="error">{{errorMessage}}</v-snackbar>

    <v-form>
      <v-card>
        <v-card-title primary-title>
          <v-layout row wrap>
            <v-flex xs12>
              <span class="headline">Obnova hesla</span>
            </v-flex>
            <v-flex xs12>
              <span>Zadajte svoje nové heslo</span>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-text-field
              v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(.*?).{6,}$/ }"
              data-vv-as="Heslo"
              :error-messages="errors.collect('regPassword')"
              prepend-icon="lock"
              name="regPassword"
              label="Heslo"
              type="password"
              v-model="resetPassword.password"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-validate="{required: true, is: resetPassword.password}"
              data-vv-as="Potvrdenie hesla"
              :error-messages="errors.collect('regConfirmPassword')"
              prepend-icon="lock"
              name="regConfirmPassword"
              label="Potvrdenie hesla"
              type="password"
              v-model="resetPassword.confirmPassword"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <small>*Heslo musí mať minimálne 6 znakov. Musí obsahovať veľké/malé znaky, číslo.</small>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="authStatus == 'loading'"
            :disabled="authStatus == 'loading'"
            color="primary"
            @click.prevent="submit"
          >
            <span>Reset</span>
            <span slot="loader" class="custom-loader">
              <v-icon light>cached</v-icon>
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import * as types from "@/store/types";
export default {
  data() {
    return {
      showAlert: false,
      showAlertTimout: 3000,
      errorMessage: "Nepodarilo sa resetovať heslo",
      resetPassword: {
        password: "",
        confirmPassword: ""
      }
    };
  },
  computed: {
    authStatus() {
      return this.$store.getters.authStatus;
    }
  },
  methods: {
    submit: function() {
      this.$validator.validate().then(result => {
        if (result) {
          const payload = {
            Email: this.$route.query.email,
            Token: this.$route.query.token,
            Password: this.resetPassword.password
          };
          this.$store
            .dispatch(types.AUTH_RESET_PASSWORD, payload)
            .then(() => {
              this.$router.push({ path: "/auth" });
              console.log("reset password");
            })
            .catch(e => {
              this.showAlert = true;
              console.error(e);
            });
        }
      });
    }
  }
};
</script>
<style>
</style>
